import { apiSlice } from "./ApiSlice";

const GetallappointmentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    Getallappointments: builder.query({
      query: (clinicUserId) => {
        
        return {
          url: `/api/ClinicProfile/GetAppointmentlistView?userClinicID=${clinicUserId}`,
          method: "GET"
        };
      },
      providesTags: ["Appointments"],
    }),
      getPatientReportsByClinicId: builder.query({
    query: (clinicUserId) => {
      
      return {
        url: `/api/ClinicProfile/GetLabTestPatientInfo?userClinicID=${clinicUserId}`,
        method: "GET"
      };
    },
    providesTags: ["PatientReports"],
  }),

    uploadLabReport: builder.mutation({
    query: (formData) => ({
      url: `/api/ClinicProfile/UploadLabReport`,
      method: "POST",
      body: formData,
    }),
    invalidatesTags: ['PatientReports']
  }),

  getLabReport: builder.query({
    query: ({patientUserUniqueID, appointmentID, doctorUserUniqueID}) => ({
      url: `/api/ClinicProfile/GetLabReportview?patientUserUniqueID=${patientUserUniqueID}&appointmentID=${appointmentID}&doctorUserUniqueID=${doctorUserUniqueID??""}`,
      method: "GET",
    }),
    providesTags: ["PatientReports"],
  }),

  getLabReportEdit: builder.query({
    query: ({patientUserUniqueID, appointmentID}) => ({
      url: `/api/ClinicProfile/GetLabReport-Edit?patientUserUniqueID=${patientUserUniqueID}&appointmentID=${appointmentID}`,
      method: "GET",
    }),
    providesTags: ["PatientReports"],
  }),

    Getdropdowndata: builder.query({
      query: (clinicUserId) => {
        
        return {
          url: `/api/ClinicProfile/AppointmentDropdowns?userClinicId=${clinicUserId}`,
          method: "GET"
        };
      },
    }),

     addSchedule: builder.mutation({
            query: formData => ({
                 url: "/api/ClinicProfile/DoctorAvaialabilityTimings",
                    method: 'POST',
                    body: formData,
            })
        }),

       PostFilteredAppointments: builder.mutation({
         query: (data) => ({
           url: `/api/ClinicProfile/AppointmentsTableFilter`,
           method: "POST",
           body: data,
         }),
       }) 

  }),
});

export const { useLazyGetLabReportQuery, usePostFilteredAppointmentsMutation, useLazyGetLabReportEditQuery, useGetLabReportEditQuery, useLazyGetallappointmentsQuery, useGetPatientReportsByClinicIdQuery, useUploadLabReportMutation, useGetLabReportQuery,useGetdropdowndataQuery,useAddScheduleMutation } = GetallappointmentsApiSlice;